export default __webpack_public_path__ + "static/media/DSC_0497.7f575074.webp";